import { OverlayView } from "@react-google-maps/api";
import { useDispatch } from "react-redux";
import { setFocusedBranch } from "../../features/branchUserLocations/branchUserLocationsSlice";
import styled from "styled-components";


const Container = styled.div`
    background-color: #000;
    color: #ffff;
    padding: 0px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.5);
    transform: translate(-50%, -100%);


    &:hover{
        background-color: var(--color-main);
    }
`

const CustomInfoWindow = ({ mapRef, position, center, content, branchItem }) => {


  const dispatch = useDispatch()

  const handleFocus = () => {
    const coords = {
        north: center.lat,
        east: center.lng,
        south: center.lat,
        west: center.lng
    }
      const offset = 0.008; // yaklaşık 500 metre çevre
        const bounds = new window.google.maps.LatLngBounds();
    bounds.extend(new window.google.maps.LatLng(coords.north + offset, coords.east + offset));
    bounds.extend(new window.google.maps.LatLng(coords.south - offset, coords.west - offset));
    mapRef.current.fitBounds(bounds);
  }

  return (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <Container  onClick={() => {handleFocus(); dispatch(setFocusedBranch(branchItem))}}>
        {content}
      </Container>
    </OverlayView>
  );
};


export default CustomInfoWindow